import { render, staticRenderFns } from "./Plashka.vue?vue&type=template&id=3d920a93&scoped=true"
import script from "./Plashka.vue?vue&type=script&lang=js"
export * from "./Plashka.vue?vue&type=script&lang=js"
import style0 from "./Plashka.vue?vue&type=style&index=0&id=3d920a93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d920a93",
  null
  
)

export default component.exports